import axios from "axios"
import { useState, useEffect } from "react"

const useFetchPost = (url, body) => {
    const [data, setData] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
  
    useEffect(() => {
        const controller = new AbortController()
        const fetchData = () => {
            const signal = controller.signal
            // fetch(url, {
            //     signal,
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(body)
            // })
            axios({
                method: 'post',
                url: url,
                data: body,
                signal: signal,
                headers: { 'Content-Type': 'application/json' }
            })
            .then(res => res.data)
            .then(res => {
                setData(res)
                setIsLoading(false)
            })
            .catch((e) =>{ setError(e);setIsLoading(false)})
        }
        setData()
        if(url) {
            setIsLoading(true)
            fetchData()
        } 
        return () => {
            controller.abort()
            setIsLoading(false)
        }
    },[url, body])
  
    return { error, isLoading, data }
}

export default useFetchPost